export default "__VITE_ASSET__BwYm5jJu__"